import type { FieldErrors } from "react-hook-form";

/**
 * Maps form field paths to tab IDs for trip edit page.
 * Used to highlight tabs with validation errors and auto-switch to first errored tab.
 */
export const TRIP_FIELD_TO_TAB: Record<string, string> = {
  // Basic info tab
  title: "basic",
  slug: "basic",
  destinationId: "basic",
  guideId: "basic",
  guideVideoUrl: "basic",
  priceFrom: "basic",
  priceOriginal: "basic",
  durationDays: "basic",
  groupSizeMin: "basic",
  groupSizeMax: "basic",
  tripType: "basic",
  tripStyle: "basic",
  difficultyLevel: "basic",
  shortDescription: "basic",
  description: "basic",
  featuredImage: "basic",
  isFeatured: "basic",
  isLastMinute: "basic",
  hasCzechGuide: "basic",
  allowsOnlineBooking: "basic",
  status: "basic",
  tags: "basic",
  // Itinerary
  itinerary: "itinerary",
  // Included
  included: "included",
  excluded: "included",
  note: "included",
  // Gallery
  galleryImages: "gallery",
  mapImage: "gallery",
  // Dates
  dates: "dates",
  // Content
  youtubeVideos: "content",
  faqs: "content",
  socialReels: "content",
  guideRecommendation: "content",
  relatedItems: "content",
  upgradeIds: "content",
  heroTitle: "content",
  heading: "content",
  metaTitle: "content",
  metaDescription: "content",
};

/**
 * Returns the first tab ID that has any validation error, or null.
 * Used for auto-switching to errored tab on submit failure.
 */
export function getFirstTabWithErrors(
  errors: FieldErrors,
  mapping: Record<string, string>,
): string | null {
  for (const fieldPath of Object.keys(errors)) {
    const root = fieldPath.split(".")[0];
    if (mapping[root]) return mapping[root];
  }
  return null;
}

/**
 * Returns set of tab IDs that have any validation error.
 * Used for rendering red dot indicators on tab nav.
 */
export function getTabsWithErrors(
  errors: FieldErrors,
  mapping: Record<string, string>,
): Set<string> {
  const tabs = new Set<string>();
  for (const fieldPath of Object.keys(errors)) {
    const root = fieldPath.split(".")[0];
    if (mapping[root]) tabs.add(mapping[root]);
  }
  return tabs;
}
